import Character2 from '@assets/icons/character2.svg'
import { Icon } from './Icon'

export const Character2Icon = Icon(Character2)
